import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';
import { Floor } from 'src/app/model/Master/floor';
import { PageRequestWithParameter } from 'src/app/model/Master/page-request-with-parameter';
import { HandleError, HttpErrorHandlerService } from '../http-error-handler.service';
import { catchError } from 'rxjs/operators';
import { OrganiserLocation } from 'src/app/model/OrganiserLocation/organiser-location';
import { OrganiserClass } from 'src/app/model/Master/OganiserClass/organiser-class';
// import { throwMatDialogContentAlreadyAttachedError } from '@angular/material/dialog';
import { Department } from 'src/app/model/AssetSetUp/department';
import { CompanyMasterInitialData } from 'src/app/model/Master/Company/company-master-initial-data';
import { RequestView } from 'src/app/model/OrderManagement/OrderStock/RewMaterials/RequestView/request-view';


@Injectable({
  providedIn: 'root'
})
export class MastercontainerService {

  private handleError: HandleError

  constructor(
    private http: HttpClient,
    private apiUrl: APIFactoryEndPoints,
    httpErrorHandle: HttpErrorHandlerService
  ) {
    this.handleError = httpErrorHandle.createHandleError('MastercontainerService');
  }

  getProcessInitialData(url: string) {
    return this.http.get(url);
  }
  getProductionMachineInitialData(url: string, locId: number) {
    return this.http.get(url + "/" + locId);
  }
  getAllProductionMachines(url: string) {
    return this.http.get(url);
  }
  getProductionMachineNames(url: string, machineName: string) {
    return this.http.get(url + "/" + machineName);
  }
  getProductionMachineById(url: string, refNo: string) {
    return this.http.get(url + "/" + refNo);
  }
  updateProductionMachineStatus(url: string, refNo: string, status: boolean) {
    return this.http.get(url + "/" + refNo + "/" + status);
  }
  getAssetBySubgroup(url: string, code: number) {
    return this.http.get(url + "/" + code);
  }

  getImage(url: string, img: String): any {
    return this.http.get<any>(url + img, { responseType: 'arraybuffer' as 'json' })
      .pipe(
        catchError(this.handleError('getImage', "SORRY"))
      );
  }

  getUploadedImage(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: "blob" });
  }

  getChildLocationsByLocCode(url: string, locCode: number) {
    return this.http.get(url + "/" + locCode);
  }

  //Company
  getCompanyInitialData(url: string) {
    return this.http.get<CompanyMasterInitialData>(url);
  }
  getIndustrySegmentsByIndustry(url: string, industryCode: number) {
    return this.http.get(url + "/" + industryCode)
    // .pipe(
    //   catchError(this.handleError('getIndustrySegmentsByIndustry()', []))
    // );
  }
  searchCompany(url: string, copmanyName: string) {
    return this.http.get(url + "/" + copmanyName)
    // .pipe(
    //   catchError(this.handleError('searchCompany()', []))
    // );
  }
  //ServiceMan
  getServiceManInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getEmployeesByLocationAndName(url: string, location: number, word: string) {
    return this.http.get(url + "/" + location + "/" + word)
    // .pipe(
    //   catchError(this.handleError('getEmployeesByLocationAndName()', []))
    // );
  }
  getServiceMansByLocation(url: string, word: string) {
    return this.http.get(url + "/" + word)
    // .pipe(
    //   catchError(this.handleError('getServiceMansByLocation()', []))
    // );
  }

  //Product
  getProductInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getProductMatrixsByInventoryType(url: string, inventoryTypeCode: any) {
    return this.http.get(url + "/" + inventoryTypeCode)
    // .pipe(
    //   catchError(this.handleError('getProctMatrixsByInventoryType()', []))
    // );
  }
  getProductGroupsByProductMatrix(url: string, code: any) {
    return this.http.get(url + "/" + code)
    // .pipe(
    //   catchError(this.handleError('getProductGroupsByProductMatrix()', []))
    // );
  }
  getProductSubGroupsByProductGroup(url: string, code: any) {
    return this.http.get(url + "/" + code)
    // .pipe(
    //   catchError(this.handleError('getProductSubGroupsByProductGroup()', []))
    // );
  }
  getFloorsBySingleLocation(url: string, locationCode: number) {
    return this.http.get(url + "/" + locationCode)
    // .pipe(
    //   catchError(this.handleError('getFloorsBySingleLocation()', []))
    // );
  }
  getStoragePointByFloor(url: string, floorCode: number) {
    return this.http.get(url + "/" + floorCode)
    // .pipe(
    //   catchError(this.handleError('getStoragePointByFloor()', []))
    // );
  }
  getStorageByStoragePoint(url: string, storagePointCode: number) {
    return this.http.get(url + "/" + storagePointCode)
    // .pipe(
    //   catchError(this.handleError('getStorageByStoragePoint()', []))
    // );
  }
  getProducts(url: string, productName: string) {
    return this.http.get(url + "/" + productName)
    // .pipe(
    //   catchError(this.handleError('getProducts()', []))
    // );
  }


  getByUrl(url: string) {
    return this.http.get(url);
  }


  //Employee
  getEmployeeInitialData(url: string, locationCode: number) {
    return this.http.get<Object>(url + "/" + locationCode);
  }
  getSupervisors(url: string) {
    return this.http.get(url)
    // .pipe(
    //   catchError(this.handleError('getSupervisors()', []))
    // );
  }
  getLocationsByCompany(url: string, code: number) {
    return this.http.get(url + "/" + code)
    // .pipe(
    //   catchError(this.handleError('getLocationsByCompany()', []))
    // );
  }
  getEmployees(url: string, employeeName: string) {
    return this.http.get(url + "/" + employeeName)
    // .pipe(
    //   catchError(this.handleError('getEmployees()', []))
    // );
  }
  getEmployeesByDeptAndWord(url: string, companyCodde: number) {
    return this.http.get(url + "/" + companyCodde)
    // .pipe(
    //   catchError(this.handleError('getEmployeesByDeptAndWord()', []))
    // );
  }


  //Asset
  getAssetInitialData(url: string, locationCode: number) {
    return this.http.get<Object>(url + "/" + locationCode);
  }
  getProductGroupsByMatrix(url: string, code: number) {
    return this.http.get(url + "/" + code)
    // .pipe(
    //   catchError(this.handleError('getProductGroupsByMatrix()', []))
    // );
  }
  getProductSubGroupsByGroup(url: string, code: number) {
    return this.http.get(url + "/" + code)
    // .pipe(
    //   catchError(this.handleError('getProductSubGroupsByGroup()', []))
    // );
  }
  getSubGroupOfAccounts(url: string) {
    return this.http.get(url)
    // .pipe(
    //   catchError(this.handleError('getSubGroupOfAccount()', []))
    // );
  }
  getAssets(url: string, assetName: string) {
    return this.http.get(url + "/" + assetName)
    // .pipe(
    //   catchError(this.handleError('getAssets()', []))
    // );
  }
  getAllAssets(url: string) {
    return this.http.get(url);
  }

  getAssignedAssets(url: string, locCode: number) {
    return this.http.get(url + "/" + locCode)
    // .pipe(
    //   catchError(this.handleError('getAssignedAssets()', []))
    // );
  }

  getLatestEmployeesByAssetCodeFromDispatch(url: string, assetCode: string, requestView: RequestView) {
    return this.http.post(url + "/" + assetCode, requestView)
    // .pipe(
    //   catchError(this.handleError('getLatestEmployeesByAssetCodeFromDispatch()', []))
    // );
  }

  getLatestAssetByEmployeeCodeFromDispatch(url: string, assetCode: string, requestView: RequestView) {
    return this.http.post(url + "/" + assetCode, requestView)
    // .pipe(
    //   catchError(this.handleError('getLatestAssetByEmployeeCodeFromDispatch()', []))
    // );
  }
  //Location
  getLocationInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getParentLocationByCompany(url: string, companyCode: number) {
    return this.http.get(url + "/" + companyCode)
      .pipe(
        catchError(this.handleError('getParentLocationByCompany()', []))
      );
  }
  getCityByDistrict(url: string, code: number) {
    return this.http.get(url + "/" + code)
    // .pipe(
    //   catchError(this.handleError('getCityByDistrict()', []))
    // );
  }
  getLocationByName(url: string, word: string) {
    return this.http.get<any>(url + "/" + word)
    // .pipe(
    //   catchError(this.handleError('getLocationByName()', []))
    // );
  }

  //Route
  getRouteInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getRoutes(url: string, routeName: string) {
    return this.http.get(url + "/" + routeName)
    // .pipe(
    //   catchError(this.handleError('getRoutes()', []))
    // );
  }

  //Coupon
  getCoupons(url: string, couponName: string) {
    return this.http.get(url + "/" + couponName)
    // .pipe(
    //   catchError(this.handleError('getCoupons()', []))
    // );
  }

  //Supplier
  getSupplierInitialData(url: string, locationId: number) {
    return this.http.get<Object>(url + "/" + locationId);
  }
  getAllStatesForSupplier(url: string) {
    return this.http.get(url)
    // .pipe(
    //   catchError(this.handleError('getAllStatesForSupplier()', []))
    // );
  }
  getSuppliers(url: string, supplierName: string) {
    return this.http.get(url + "/" + supplierName)
    // .pipe(
    //   catchError(this.handleError('getOrganiserDetails()', []))
    // );
  }

  //Organiser Detail
  getOrganiserDetailInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getOrganiserDetails(url: string, organiserDetailsName: string) {
    return this.http.get(url + "/" + organiserDetailsName)
    // .pipe(
    //   catchError(this.handleError('getOrganiserDetails()', []))
    // );
  }

  //Organiser
  getOrganiserInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getOrganisers(url: string, organiserName: string) {
    return this.http.get(url + "/" + organiserName)
    // .pipe(
    //   catchError(this.handleError('getOrganisers()', []))
    // );
  }

  //Customer
  getCustomerInitialData(url: string, locationId: number) {
    return this.http.get<Object>(url + "/" + locationId);
  }
  getAllStatesForCustomer(url: string) {
    return this.http.get(url)
    // .pipe(
    //   catchError(this.handleError('getAllStatesForCustomer()', []))
    // );
  }
  getCustomers(url: string, customerMobile: string) {
    return this.http.get(url + "/" + customerMobile)
    // .pipe(
    //   catchError(this.handleError('getCustomers()', []))
    // );
  }

  //SubGroup
  getSubGroupInitialData(url: string) {
    return this.http.get<Object>(url);
  }

  getProductGroupByProductMatrix(url: string, productMatrixCode: number[]) {
    return this.http.get(url + "/" + productMatrixCode)
    // .pipe(
    //   catchError(this.handleError('getProductGroupByProductMatrix()', []))
    // );
  }
  getProductSubGroupsByGroupIds(url: string, groupCodes: number[]) {
    return this.http.get(url + "/" + groupCodes);
  }
  getAllProductsIdAndName(url: string) {
    return this.http.get(url);
  }
  getSubGroups(url: string, productSubGroupName: string) {
    return this.http.get(url + "/" + productSubGroupName)
    // .pipe(
    //   catchError(this.handleError('getSubGroups()', []))
    // );
  }

  getAssetsByLocationAndSubGroup(url: string, locCodes: number[], assetSubGroupCodes: number[]) {
    return this.http.get(url + '/' + locCodes + '/' + assetSubGroupCodes)
  }

  //Group
  getGroupInitialData(url: string) {
    return this.http.get<object>(url);
  }
  getProductMatrixByInventoryType(url: string, inventoryTypeCode: number[]) {
    return this.http.get(url + "/" + inventoryTypeCode)
    // .pipe(
    //   catchError(this.handleError('getProctMatrixByInventoryType()', []))
    // );
  }
  getGroups(url: string, productGroupName: string) {
    return this.http.get(url + "/" + productGroupName)
    // .pipe(
    //   catchError(this.handleError('getGroups()', []))
    // );
  }
  getAllInventory(url: string) {
    return this.http.get(url);
  }

  //Matrix
  getMatrixInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getMatrixs(url: string, productMatrixName: string) {
    return this.http.get(url + "/" + productMatrixName)
    // .pipe(
    //   catchError(this.handleError('getMatrixs()', []))
    // );
  }

  //Storage
  getStorageInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getLocations(url: string) {
    return this.http.get(url);
  }
  getFloorsByLocation(url: string, locationCode: number[]) {
    return this.http.get(url + "/" + locationCode)
    // .pipe(
    //   catchError(this.handleError('getFloorsByLocation()', []))
    // );
  }
  getStoragePointByFloors(url: string, floorCode: number[]) {
    return this.http.get(url + "/" + floorCode)
    // .pipe(
    //   catchError(this.handleError('getStoragePointByFloors()', []))
    // );
  }
  getStorages(url: string, storageName: string) {
    return this.http.get(url + "/" + storageName)
    // .pipe(
    //   catchError(this.handleError('getStorages()', []))
    // );
  }

  //StoragePoint
  getStoragePointInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getStoragePoints(url: string, storagePointName: string) {
    return this.http.get(url + "/" + storagePointName)
    // .pipe(
    //   catchError(this.handleError('getStoragePoints()', []))
    // );
  }

  //Department 
  getDepartmentInitialData(url: string) {
    return this.http.get<number>(url);
  }
  getdepartmentList(url: string, word: string) {
    return this.http.get<Department[]>(url + "/" + word)
  }

  //Bank
  getBannkInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getBanks(url: string, bankName: string) {
    return this.http.get(url + "/" + bankName);
  }

  //Crate
  getCrateInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getCrates(url: string, crateName: string) {
    return this.http.get(url + "/" + crateName);
  }

  //Organiser Class 
  organiserClassInitialData(url: string) {
    return this.http.get<number>(url);
  }
  organiserClassDataByWord(url: string, word: string) {
    return this.http.get<OrganiserClass[]>(url + "/" + word)
  }

  //Designation
  getDesignationInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getDesignations(url: string, designation: string) {
    return this.http.get(url + '/' + designation)
    // .pipe(
    //   catchError(this.handleError('getDesignations()', []))
    // );
  }

  //ProductBatch
  getProductBatchInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getProductBatchs(url: string, batchName: string) {
    return this.http.get(url + '/' + batchName)
    // .pipe(
    //   catchError(this.handleError('getProductBatch()', []))
    // );
  }

  //Brand
  getBrandInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getBrands(url: string, brandName: string) {
    return this.http.get(url + "/" + brandName)
    // .pipe(
    //   catchError(this.handleError('getBrands()', []))
    // );
  }

  //SalesChannel
  getSalesChannelInitialData(url: string) {
    return this.http.get<any>(url);
  }
  getSalesChannels(url: string, salesChannelName: string) {
    return this.http.get(url + '/' + salesChannelName)
    // .pipe(
    //   catchError(this.handleError('getSalesChannel()', []))
    // );
  }

  getProductMatrixs(url: string) {
    return this.http.get(url);
  }

  getProductGroupsByMatrixCode(url: string, matrixCode: number) {
    return this.http.get(url + "/" + matrixCode);
  }

  getProductSubGroupsByGroupCode(url: string, groupCode: number) {
    return this.http.get(url + "/" + groupCode);
  }
  //JobRole
  getJobRoleInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getJobRoles(url: string, jobRoleName: string) {
    return this.http.get(url + '/' + jobRoleName)
    // .pipe(
    //   catchError(this.handleError('getJobRoles()', []))
    // );
  }

  //CustomerClass
  getCustomerClassInitialdata(url: string) {
    return this.http.get<Object>(url);
  }

  getCustomerClassNames(url: string, customerClassName: string) {
    return this.http.get(url + "/" + customerClassName)
    // .pipe(
    //   catchError(this.handleError('getCustomerClassNames()', []))
    // );
  }


  //Composition
  getCompositionInitialData(url: string) {
    return this.http.get<Object>(url);
  }

  getCompositionNames(url: string, compositionName: string) {
    return this.http.get(url + '/' + compositionName)
    // .pipe(
    //   catchError(this.handleError('getCompositionNames()', []))
    // );
  }

  //Region
  getRegionInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getRegionNames(url: string, regionName: string) {
    return this.http.get(url + "/" + regionName)
    // .pipe(
    //   catchError(this.handleError('getRegionNames()', []))
    // );
  }

  //Area
  getAreaInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  getAreas(url: string, areaName: string) {
    return this.http.get(url + "/" + areaName)
    // .pipe(
    //   catchError(this.handleError('getAreas()', []))
    // );
  }

  //floor
  getFloorInitialData(url: string) {
    return this.http.get(url);
  }
  getFloorByLocationWithAllPageble(url: string, obj: PageRequestWithParameter): Observable<any> {
    return this.http.post(
      url, obj
    );
  }
  getFloorBySearch(url: string, word: string): Observable<any> {
    return this.http.get<Floor[]>(url + "/" + word);
  }


  // CITY-
  getCityInitialData(url: string) {
    return this.http.get<Object>(url);
  }

  getStatesbyCountryCode(url: string, countryCode: number) {
    return this.http.get(url + '/' + countryCode)
    // .pipe(
    //   catchError(this.handleError('getStatesbyCountryCode()', []))
    // );
  }


  getDistrictsbyStateCodeWithAll(url: string, stateCode: number) {
    return this.http.get<Object>(url + '/' + stateCode)
    // .pipe(
    //   catchError(this.handleError('getDistrictsbyStateCodeWithAll()', []))
    // );
  }

  getPinCodeByCity(url: string, cityCode: number) {
    return this.http.get<Object>(url + '/' + cityCode);
  }

  searchCity(url: string, cityName: string) {
    return this.http.get(url + '/' + cityName)
      .pipe(
        catchError(this.handleError('searchCity()', []))
      );
  }

  //location type 
  getLocationTypeInitialData(url: string) {
    return this.http.get<Object>(url);
  }
  locationType(url: string, locTypeName: string): Observable<any> {
    return this.http.get<Floor[]>(url + "/" + locTypeName);

  }

  //organiser location
  getOrganiserLocationInitailData(url: string) {
    return this.http.get<any>(url);
  }
  getOrganiserLocations(url: string, word: string) {
    return this.http.get<OrganiserLocation[]>(
      url + '/' + word
    );
  }

  //For Export
  //Export Data to CSV
  exportMasterData(url: string, exportType: string, module: string, req: any) {
    return this.http.post(url + "/" + exportType + "/" + module, req, { responseType: 'arraybuffer' })
    // .pipe(
    //   catchError(this.handleError('exportMasterData()', []))
    // );
  }

  getFile(url: string, fileName: string): any {
    return this.http.get(url + fileName, { responseType: 'arraybuffer' as 'json' });

  }

  updateSetupStatus(url: string, refNo: number, status: boolean) {
    return this.http.get(url + "/" + refNo + "/" + status);
  }

  updatePromotionMasterStatus(url: string, refNo: number, status: string) {
    return this.http.get(url + "/" + refNo + "/" + status);
  }
  getInternationalizationInitialData(url: string) {
    return this.http.get(url);
  }
  convertFiles(formData: FormData, url: string): Observable<HttpResponse<Blob>> {
    return this.http.post(
      url,
      formData,
      {
        observe: 'response',
        responseType: 'blob'
      }
    );
  }

  getLatestPackagecode(url: string) {
    return this.http.get(url);
  }
}
